import * as React from "react";
import { cn } from "@/lib/utils";

const CHEVRON_SVG =
  "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\")";

const chevronStyle: React.CSSProperties = {
  backgroundImage: CHEVRON_SVG,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 1rem center",
  backgroundSize: "12px",
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
};

export interface NativeSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
  variant?: "default" | "compact";
}

/**
 * Shared native <select> with a custom chevron and consistent spacing.
 * Use this in place of raw <select> elements across the app.
 */
const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, invalid, variant = "default", style, children, ...props }, ref) => {
    const base =
      variant === "compact"
        ? "flex h-10 w-full rounded-md border bg-background px-3 py-2 pr-10 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        : "w-full rounded-xl border px-4 py-3 pr-10 text-sm bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary transition";

    const borderClass = invalid
      ? "border-destructive focus:ring-destructive focus-visible:ring-destructive"
      : variant === "compact"
        ? "border-input"
        : "border-border";

    return (
      <select
        ref={ref}
        style={{ ...chevronStyle, ...style }}
        className={cn(base, borderClass, className)}
        {...props}
      >
        {children}
      </select>
    );
  },
);
NativeSelect.displayName = "NativeSelect";

export { NativeSelect };
